export default class InvoiceTemplate {
    static fromData(data) {
        if (!data) {
            return;
        }

        const invoiceTemplate = new InvoiceTemplate();
        invoiceTemplate.id = data.id;
        invoiceTemplate.name = data.name;
        invoiceTemplate.active = data.active;
        invoiceTemplate.type = data.type;
        invoiceTemplate.stationeryId = data.stationeryId;
        invoiceTemplate.isAllowedToEdit = data.isAllowedToEdit;

        return invoiceTemplate;
    }

    serialize() {
        return {
            id: this.id,
            active: this.active,
            type: this.type,
            stationeryId: this.stationeryId
        };
    }
}
